import React from 'react'
import { makeStyles, Box, Typography } from '@material-ui/core'
import { clsx } from 'clsx'
import feature_1 from "../images/features/feature_1.svg"
import feature_2 from "../images/features/feature_2.svg"
import feature_3 from "../images/features/feature_3.svg"

const useStyles = makeStyles((theme) => ({
    sectionTitle: {
        fontFamily: '"Cormorant Garamond", serif',
        fontSize: "52px",
        fontWeight: 400,
        lineHeight: "100%",
        textAlign: "left",
        [theme.breakpoints.down('sm')]: {
            fontSize: "36px",
            lineHeight: '100%',
        },
    },
    sectionText: {
        fontFamily: '"Roboto", sans-serif',
        fontSize: '18px',
        color: '#ffffff',
        lineHeight: "27px",
        fontWeight: 200,
        [theme.breakpoints.down('sm')]: {
            fontSize: '16px',
            opacity: 0.9,
            lineHeight: '24px',
        },
    },
    featuresSection: {
        maxWidth: 1314,
        margin: "0 auto",
        padding: "60px 24px",
        textAlign: "center",
        boxSizing: 'border-box',
        [theme.breakpoints.down('sm')]: {
            padding: "36px 21px",
        },
    },
    featuresHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: 40,
        flexWrap: 'wrap',
        gap: 24,
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
        },
    },
    featuresTitle: {
        maxWidth: "50%",
        [theme.breakpoints.down('sm')]: {
            maxWidth: '100%',
            textAlign: 'center',
        },
    },
    featuresDescription: {
        width: "50%",
        maxWidth: "418px",
        textAlign: "left",
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            textAlign: 'center',
        },
    },
    featuresGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: "40px",
        [theme.breakpoints.down('sm')]: {
            gridTemplateColumns: '1fr',
        },
    },
    featureCard: {
        textAlign: 'left',
        padding: "24px",
        backgroundColor: "#1B1B1B",
        borderRadius: "8px",
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        [theme.breakpoints.down('sm')]: {
            textAlign: 'center',
            alignItems: 'center',
        }
    },
    featureIcon: {
        width: 60,
        height: 60,
        marginBottom: theme.spacing(3),
        opacity: 0.8,
    },
    featureTitle: {
        fontFamily: '"Cormorant Garamond", serif',
        fontSize: '28px',
        fontWeight: 500,
        marginBottom: 8,
        [theme.breakpoints.down('sm')]: {
            fontSize: '24px',
        },
    },
    featureDescription: {
        fontFamily: '"Roboto", sans-serif',
        fontSize: '16px',
        lineHeight: 1.3,
        fontWeight: 200,
        color: "#FFFFFFE5",
        opacity: 0.8,
        [theme.breakpoints.down('sm')]: {
            fontSize: '14px',
            fontWeight: 400,
        },
    },
}))

export const FeaturesSection: React.FC = () => {
    const classes = useStyles()
    return (
        <Box className={classes.featuresSection}>
            <Box className={classes.featuresHeader}>
                <Typography variant="h2" className={clsx(classes.sectionTitle, classes.featuresTitle)}>
                    An elevated way <br /> to engage.
                </Typography>
                <Typography className={clsx(classes.sectionText, classes.featuresDescription)}>
                    Your time is valuable. Stop scrolling through endless, uncurated noise. SugarCribs is designed entirely around intentional matching, elite privacy, and premium experiences.
                </Typography>
            </Box>
            <Box className={classes.featuresGrid}>
                <Box className={classes.featureCard}>
                    <img className={classes.featureIcon} src={feature_1} alt="Elite Curation" />
                    <Typography className={classes.featureTitle}>Elite Curation</Typography>
                    <Typography className={classes.featureDescription}>
                        Engage exclusively with the top tier of independent creators. We hand-select our creators to ensure a standard of unparalleled quality.
                    </Typography>
                </Box>
                <Box className={classes.featureCard}>
                    <img className={classes.featureIcon} src={feature_2} alt="Total Discretion" />
                    <Typography className={classes.featureTitle}>Total Discretion</Typography>
                    <Typography className={classes.featureDescription}>
                        A privacy-first architecture built to protect your identity. Strict verification ensures a secure, high-intent environment for all members.
                    </Typography>
                </Box>
                <Box className={classes.featureCard}>
                    <img className={classes.featureIcon} src={feature_3} alt="Premium Access" />
                    <Typography className={classes.featureTitle}>Premium Access</Typography>
                    <Typography className={classes.featureDescription}>
                        Unlock exclusive VIP subscriptions, discreet 1-on-1 direct messaging, and high-value custom requests.
                    </Typography>
                </Box>
            </Box>
        </Box>
    )
}
